import React, { useEffect, useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { X, MessageCircle, Phone } from 'lucide-react';
export const WhatsAppWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isClosedByUser, setIsClosedByUser] = useState(false);
  // Phone number for WhatsApp
  const phoneNumber = '31625023378';
  const whatsappMessage = 'Hallo, ik heb een vraag over Veranova Klussen.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  useEffect(() => {
    // Don't show if user closed it
    if (isClosedByUser) return;
    // Set timeout based on device type
    const timeout = setTimeout(() => {
      setIsVisible(true);
      // Show chat bubble after initial appearance
      setTimeout(() => {
        if (!isClosedByUser) {
          setIsChatOpen(true);
        }
      }, 5000); // Show chat bubble 5 seconds after the icon appears
    }, 10000); // Show after 10 seconds
    return () => clearTimeout(timeout);
  }, [isClosedByUser]);
  const handleClose = () => {
    setIsChatOpen(false);
    setIsClosedByUser(true);
  };
  const handleToggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end" data-id="element-1569">
      {/* Chat Bubble */}
      {isChatOpen && <div className="bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] mb-4 p-5 max-w-[320px] animate-fade-in" data-id="element-1570">
          <div className="flex justify-between items-center mb-4" data-id="element-1571">
            <div className="flex items-center gap-2" data-id="element-1572">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/on5ADKbG5v5f83NALg5Mhn/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-6 h-6" data-id="element-1573" />
              <h3 className="font-semibold text-gray-800" data-id="element-1574">Veranova Klussen</h3>
            </div>
            <button onClick={handleClose} className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Sluiten" data-id="element-1575">
              <X size={20} data-id="element-1576" />
            </button>
          </div>
          <p className="text-gray-600 text-sm mb-4 leading-relaxed" data-id="element-1577">
            Hallo! 👋 Heeft u een vraag over onze diensten? Chat direct met ons
            op WhatsApp voor snelle ondersteuning.
          </p>
          <div className="space-y-2" data-id="element-1578">
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-[#25D366] hover:bg-[#22c35e] text-white font-medium rounded-lg py-2.5 px-4 inline-flex items-center justify-center w-full transition-all duration-300 shadow-md hover:shadow-xl" data-id="element-1579">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/on5ADKbG5v5f83NALg5Mhn/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-5 h-5 mr-2" data-id="element-1580" />
              Start WhatsApp Chat
            </a>
            <a href={`tel:${phoneNumber}`} className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg py-2.5 px-4 inline-flex items-center justify-center w-full transition-all duration-300" data-id="element-1581">
              <Phone size={18} className="mr-2" data-id="element-1582" />
              Bel direct: {phoneNumber}
            </a>
          </div>
        </div>}
      {/* WhatsApp Button */}
      <button onClick={handleToggleChat} className="bg-[#25D366] rounded-full w-14 h-14 flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.15)] hover:shadow-[0_8px_30px_rgba(37,211,102,0.25)] transform hover:scale-105 transition-all duration-300 group" aria-label="WhatsApp Chat" data-id="element-1583">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/on5ADKbG5v5f83NALg5Mhn/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-7 h-7 group-hover:scale-110 transition-transform duration-300" data-id="element-1584" />
      </button>
    </div>;
};